import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { Container } from '../../layout/Container'
import { useScrollAnimation } from '../../../hooks/useScrollAnimation'

interface ModuleOverviewProps {
  tKey: 'brain' | 'build' | 'govern'
}

export function ModuleOverview({ tKey }: ModuleOverviewProps) {
  const { t } = useTranslation()
  const { ref, isInView } = useScrollAnimation()

  return (
    <section ref={ref} className="py-24">
      <Container size="narrow">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <span className="text-sm font-medium uppercase tracking-wider text-accent-light">
            {t(`platformPages.${tKey}.overview.label`)}
          </span>
          <h2 className="mt-4 text-3xl font-semibold tracking-tight text-text-primary sm:text-4xl">
            {t(`platformPages.${tKey}.overview.title`)}
          </h2>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-text-secondary">
            {t(`platformPages.${tKey}.overview.description`)}
          </p>
        </motion.div>
      </Container>
    </section>
  )
}
